import React, { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { ButtonsWrapper, MainGrid } from './Profile.styles';
import { ProfileConfig } from './Profile.props';
import { PageContainer } from '../../components/atoms/PageContainer';
import { MultiSelectCheckmarksMenu } from '../../components/atoms/MultiSelectCheckmarksMenu';
import { Typography, TypographyVariantProps } from '../../components/atoms/Typography';
import { Button, ButtonColorProps, ButtonVariantProps } from '../../components/atoms/Button';
import { DropdownItem } from '../../components/atoms/SelectMenu';
import { Snackbar } from '../../components/atoms/Snackbar';
import { useGetZones } from '../../queries/geosocial-query';
import { useGetCurrentUser, useUpdateProfileConfig } from '../../queries/user-query';

export const Profile: React.FC = () => {
  const [profileConfig, setProfileConfig] = useState<ProfileConfig>();
  const [zoneList, setZoneList] = useState<DropdownItem[]>([]);
  const [openToast, setOpenToast] = useState<boolean>(false);
  
  const getZones = useGetZones();
  const getCurrentUser = useGetCurrentUser();
  const updateProfileConfig = useUpdateProfileConfig(getCurrentUser?.data?.id as number);

  useEffect(() => {
    getCurrentUser.refetch();
  }, []);

  useEffect(() => {
    if (getZones.data) {
      const zoneItems = getZones?.data?.map((item) => ({
        value: item.name,
        label: item.name
      })) || [];
      setZoneList(zoneItems);
    }
  }, [getZones.data]);

  useEffect(() => {
    if (getCurrentUser.data?.config) {
      setProfileConfig(getCurrentUser.data?.config);
    }
  }, [getCurrentUser.data]);

  const saveProfileConfig = async () => {
    const updatedConfig = {
      ...getCurrentUser.data?.config,
      myZones: !profileConfig?.myZones?.length || (profileConfig?.myZones?.length === 1 && profileConfig?.myZones[0] === '') ? [] : profileConfig?.myZones
    };
    await updateProfileConfig.mutateAsync({
      config: updatedConfig
    });
    setOpenToast(true);
    getCurrentUser.refetch();
  };

  const cancelProfileConfigChanges = () => {
    setProfileConfig({ ...profileConfig, myZones: getCurrentUser.data?.config?.myZones || [] });
  };

  return (
    <PageContainer>
      <Typography variant={TypographyVariantProps.H5} fontWeight={600}>
        Profile
      </Typography>
      <MainGrid container>
        <Grid>
          <Typography variant={TypographyVariantProps.H6}>My Zones</Typography>
          <Grid mt={1}>
            <MultiSelectCheckmarksMenu 
              id="my-zones"
              label="Select Zones"
              selectedValue={profileConfig?.myZones}
              onChange={(zones) => setProfileConfig({ ...profileConfig, myZones: zones.split(',') })}
              items={zoneList}
              searchEnabled
            />
          </Grid>
        </Grid>
        <ButtonsWrapper>
          <Grid>
            <Button
              variant={ButtonVariantProps.Primary}
              onClick={() => saveProfileConfig()}
            >
              Save
            </Button>
          </Grid>
          <Grid ml={2}>
            <Button
              variant={ButtonVariantProps.Secondary}
              onClick={() => cancelProfileConfigChanges()}>
              Cancel
            </Button>
          </Grid>
        </ButtonsWrapper>
      </MainGrid>
      <Snackbar  
        open={openToast} 
        autoHideDuration={4000} 
        message="Successfully updated!"
        onClose={()=> setOpenToast(false)}
        action={
          <React.Fragment>
            <Button 
              variant={ButtonVariantProps.Primary}
              color={ButtonColorProps.Success}
              onClick={()=> setOpenToast(false)}
            >
              X
            </Button>
          </React.Fragment>
        }
      />
    </PageContainer>
  );
};